import React from 'react'
import { Divider, Row, Form, Button, Input, Upload, Icon, Switch, notification } from 'antd'
import API from '../../services/API'
import Segment from '../../components/Segment'
import { Link } from 'react-router-dom'

const INIT = {
    name: '',
    image: '',
    created_by: '',
    active: true,
}

const BrandsCreateContainer = ({ user }) => {
    const [data, setData] = React.useState(INIT)
    const [loading, setloading] = React.useState(false)
    const [filesList, setFilesList] = React.useState([])
    const disabled = !data.name || !data.image

    const handleChange = (name, value) => {
        const newData = { ...data }
        newData[name] = value
        setData(newData)
    }

    const handleChangePicture = ({ fileList }) => setFilesList(fileList)

    const handleSubmit = e => {
        setloading(true)
        e.preventDefault()

        const formData = new FormData()
        formData.append('image', data.image)
        formData.append('name', data.name)
        formData.append('active', data.active ? 1 : 0)
        formData.append('created_by', user.id)

        API.post('/api/brands', formData)
            .then(() => {
                setloading(false)
                setFilesList([])
                setData(INIT)

                notification.success({
                    message: 'La marca se ha creado exitosamente',
                })
            })
            .catch(error => {
                setloading(false)
                notification.error({
                    message: 'Ha ocurrido un error al guarda la marca',
                })
                console.error(error.response)
            })
    }

    return (
        <Segment loading={loading}>
            <Divider>Crear marca</Divider>
            <Form style={{ maxWidth: '400px', margin: 'auto' }}>


                <p className="message">
                    Todos los campos marcados con un asterisco (<span>*</span>)
                    son campos obligatorios y deben ser llenados.
                </p>

                <Form.Item label="Nombre" hasFeedback>
                    <Input
                        placeholder="Escribe el nombre"
                        value={data.name}
                        onChange={e => {
                            handleChange('name', e.target.value)
                        }}
                    />
                </Form.Item>

                <Form.Item label="Logotipo" hasFeedback>
                    <Upload
                        listType="picture-card"
                        accept="image/*"
                        beforeUpload={file => {
                            handleChange('image', file)
                            return false
                        }}
                        fileList={filesList}
                        showUploadList={{
                            showRemoveIcon: true,
                            showPreviewIcon: false,
                            showDownloadIcon: false,
                        }}
                        onChange={handleChangePicture}
                        onRemove={() => {
                            handleChange('image', '')
                            setFilesList([])
                        }}
                    >
                        {!data.image ? (
                            <>
                                <Icon type="plus" />
                                <div className="ant-upload-text">Subir</div>
                            </>
                        ) : null}
                    </Upload>
                </Form.Item>

                <Form.Item label="Activo" hasFeedback>
                    <Switch
                        checked={!!data.active}
                        onChange={value => {
                            handleChange('active', value)
                        }}
                    />
                </Form.Item>

                <Row type="flex" justify="space-between" style={{ marginTop: '50px' }}>

                    <Form.Item>
                        <Link to="/brands">
                            <Button

                                icon="arrow-left"
                            >
                                Regresar
                            </Button>
                        </Link>
                    </Form.Item>
                    <Form.Item>
                        <Button
                            type="primary"
                            icon="save"
                            disabled={disabled}
                            onClick={handleSubmit}
                        >
                            Guardar
                        </Button>
                    </Form.Item>
                </Row>
            </Form>
        </Segment>
    )
}

export default BrandsCreateContainer
